declare global {
  interface Window {
    dataLayer: {
      push: (eventData: object) => void;
      filter: (item: any) => any;
    };
  }
}

export const pushVirtualPageView = (
  pageViewTitle: string,
  definitionName: string | undefined
) => {
  const waitForConsentAndPush = () => {
    if (
      Array.isArray(window.dataLayer) &&
      window.dataLayer.some((item) => item.event === "cookie_consent_update")
    ) {
      window.dataLayer.push({
        event: "virtPath",
        virtPath: `/claimcheck-airspeed/${definitionName}/${pageViewTitle}`,
      });
    } else {
      setTimeout(waitForConsentAndPush, 1000);
    }
  };
  waitForConsentAndPush();
};
